import { Dto, DtoWithId } from "@mango/core";


@Dto({fullName: "CIJBorculo.Logic.Artikelgroep"})
export class Artikelgroep extends DtoWithId {
	groep: string;
	grootboekrekening: number;
	kostenplaats: string;
}